/**
 * DE Beaut‑e‑News email signup modal — phone field behaviour:
 * - Only digits (0–9) and a leading '+' are allowed; all other characters are stripped
 * - '+' is allowed as the first character only; auto-prepended when the user omits it
 * - Maximum 15 digits (excluding '+'); minimum 9 digits when the field is populated
 * - Field is optional — validation applies only when a value is present
 * - No spaces or separators permitted
 */
(function ($) {
    /** Maximum number of digits allowed after the '+' sign */
    var MAX_DIGITS = 15;

    /**
     * Sanitize the raw input value:
     *   1. Strip every character that is not a digit or a leading '+'
     *   2. Auto-prepend '+' when the value starts with a digit
     *   3. Enforce the 15-digit maximum (excluding '+')
     * @param {string} raw - Raw value from the input element
     * @returns {string} - Sanitized phone string
     */
    function sanitize(raw) {
        // Remove everything that is not a digit or '+'
        var cleaned = raw.replace(/[^0-9+]/g, '');

        // Strip any '+' that appears after the first character
        cleaned = cleaned.replace(/^(\+?)(.*)$/, function (match, plus, rest) {
            return plus + rest.replace(/\+/g, '');
        });

        // Auto-prepend '+' if the value starts with a digit
        if (cleaned.length && cleaned.charAt(0) !== '+') {
            cleaned = '+' + cleaned;
        }

        // Enforce max length: '+' plus up to MAX_DIGITS digits
        var digits = cleaned.slice(1); // everything after '+'
        if (digits.length > MAX_DIGITS) {
            cleaned = '+' + digits.slice(0, MAX_DIGITS);
        }

        return cleaned;
    }

    /**
     * Validate the phone field value.
     * Returns true if empty (phone is optional).
     * Otherwise validates against ^\+[0-9]{9,15}$.
     * @param {jQuery} $field - jQuery-wrapped phone input
     * @returns {boolean} - Whether the phone value is valid
     */
    function isPhoneValid($field) {
        var val = $field.val();
        if (!val) {
            return true;
        }
        // Use the pattern attribute from the input markup when present; fall back to the agreed rule
        var patternAttr = $field.attr('pattern') || '^\\+[0-9]{9,15}$';
        return new RegExp(patternAttr).test(val);
    }

    $('body').on('input', '#signup-form-phone.addPlus', function () {
        var $el = $(this);
        var el = this;
        var caretPos = el.selectionStart;
        var before = $el.val();
        var after = sanitize(before);

        if (before !== after) {
            var removed = before.length - after.length;
            $el.val(after);
            var newPos = Math.max(0, caretPos - removed);
            el.setSelectionRange(newPos, newPos);
        }

        if ($el.hasClass('is-invalid')) {
            var valid = isPhoneValid($el);
            $el.toggleClass('is-invalid', !valid);
            var errorId = $el.attr('aria-describedby');
            if (errorId) {
                $('#' + errorId).text(valid ? '' : ($el.data('pattern-mismatch') || ''));
            }
        }
    });

    $('body').on('blur', '#signup-form-phone.addPlus', function () {
        var $el = $(this);
        $el.val(sanitize($el.val()));

        var valid = isPhoneValid($el);
        $el.toggleClass('is-invalid', !valid);
        var errorId = $el.attr('aria-describedby');
        if (errorId) {
            $('#' + errorId).text(valid ? '' : ($el.data('pattern-mismatch') || ''));
        }
    });
}(jQuery));